import fp from 'lodash/fp';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Grid from '../../webcommon/grid/Grid';
import FilterHeader from '../../webcommon/header/filterheader/FilterHeader';
import RefreshControls from '../../webcommon/common/refreshcontrols/RefreshControls';

import ToggleSwitch from '../../common/gridheader/toggleswitch/ToggleSwitch';
import D3Chart from './d3Chart';
import makeColumns from './columns';
import { getChartDataAdapter } from './adapters';

import * as styles from './ImpactChart.module.scss';
import { PAGE_REFRESH_RATE } from './constants';


class ImpactChartView extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();

        this.getChartState = this.getChartState.bind(this);

        this.setSorting = (newSorted) => {
            const allColumns = makeColumns(
                this.props.useDollars,
                fp.get('data.summaryDifference.firstDayDate')(this.props),
                fp.get('data.summaryDifference.lastDayDate')(this.props)
            );
            const currencyColumns = allColumns[1].columns;
            const idWithoutCurrency = fp.flow(
                fp.find(column => column.id === newSorted[0].id),
                fp.get('idWithoutCurrency')
            )(currencyColumns);
            const sortedWithStrippedId = idWithoutCurrency ? fp.set('[0].id', idWithoutCurrency)(newSorted) : newSorted;
            this.props.setSorting([{ gridId: 'imcharting', gridSort: sortedWithStrippedId }]);
        };

        this.setGridSorts = (gridSorts) => {
            const allColumns = makeColumns(
                this.props.useDollars,
                fp.get('data.summaryDifference.firstDayDate')(this.props),
                fp.get('data.summaryDifference.lastDayDate')(this.props)
            );
            const currencyColumns = allColumns[1].columns;
            if (gridSorts) {
                return gridSorts.map((columnSort) => {
                    const currencyId = fp.flow(
                        fp.find(column => column.idWithoutCurrency === columnSort.id),
                        fp.get('id')
                    )(currencyColumns);
                    return currencyId ? fp.set('id', currencyId)(columnSort) : columnSort;
                });
            }
            return [];
        };
    }

    componentDidMount() {
        this.props.initialised();
        this.d3Chart = new D3Chart(
            this.chartRef.current,
            this.getChartState()
        );
        this.d3Chart.render();
        const continuousDataLoad = setInterval(() => {
            this.props.refreshCsaChart();
        }, PAGE_REFRESH_RATE);
        return () => clearInterval(continuousDataLoad);
    }

    componentDidUpdate() {
        this.d3Chart.render(this.getChartState());
    }

    getChartState() {
        return fp.flow(
            fp.getOr([], 'data.summaryAggregations'),
            getChartDataAdapter(this.props.useDollars)
        )(this.props);
    }

    render() {
        return (
            <div className={ styles.container }>
                <div className={ styles.headerWrapper }>
                    <FilterHeader
                        id="IM_MONITORING"
                        title="IM Charting"
                        fixed
                        refreshControls={ {
                            onClick: this.props.refreshData,
                            timeLastUpdated: null
                        } }
                    />
                    <div className={ styles.currencySelection }>
                        <ToggleSwitch
                            optionLeft="EUR"
                            optionRight="USD"
                            toggleIsLeft={ !this.props.useDollars }
                            toggleSwitch={ this.props.switchCurrencies }
                        />
                    </div>
                    <div className={ styles.refreshControlsWrapper }>
                        <RefreshControls
                            onClick={ this.props.fetchImMonitoring }
                            timeLastUpdated={ this.props.timeLastUpdated }
                        />
                    </div>
                    <div className={ styles.ChartTitle }>IM <span className={ styles.orange }>Calculated</span> &amp; <span className={ styles.blue }>Posted</span></div>
                </div>
                <div className={ styles.Chart } ref={ this.chartRef } />
                <div className={ styles.gridContainer }>
                    <Grid
                        loading={ this.props.fetching }
                        columns={ makeColumns(
                            this.props.useDollars,
                            fp.get('data.summaryDifference.firstDayDate')(this.props),
                            fp.get('data.summaryDifference.lastDayDate')(this.props)
                        ) }
                        rows={ fp.getOr([], 'data.summaryDifference.data')(this.props) }
                        defaultColumnSpacing={ 2 }
                        defaultSorted={ this.setGridSorts(fp.get('sorting[0].gridSort')(this.props)) }
                        onSortedChange={ this.setSorting }
                    />
                </div>
            </div>
        );
    }
}

ImpactChartView.propTypes = {
    data: PropTypes.shape({}),
    fetching: PropTypes.bool,
    initialised: PropTypes.func.isRequired,
    useDollars: PropTypes.bool,
    switchCurrencies: PropTypes.func.isRequired,
    setSorting: PropTypes.func.isRequired,
    fetchImMonitoring: PropTypes.func.isRequired,
    timeLastUpdated: PropTypes.number,
    refreshData: PropTypes.func.isRequired
};

ImpactChartView.defaultProps = {
    data: null,
    fetching: false,
    useDollars: false,
    timeLastUpdated: null
};

export default ImpactChartView;
